import { render, staticRenderFns } from "./TreemapChartApex.vue?vue&type=template&id=bfc17a36"
import script from "./TreemapChartApex.vue?vue&type=script&lang=js"
export * from "./TreemapChartApex.vue?vue&type=script&lang=js"
import style0 from "./TreemapChartApex.vue?vue&type=style&index=0&id=bfc17a36&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports